var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 1024 1024",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "200",
        "height": "200"
      }, attrs)
    }, rest), children.concat([_c('defs'), _c('path', {
      attrs: {
        "d": "M875.2 220.8L571.2 64c-36.8-19.2-81.6-19.2-118.4 0l-304 158.4c-41.6 19.2-68.8 64-68.8 112v356.8c0 48 27.2 91.2 68.8 113.6l305.6 158.4c17.6 9.6 38.4 14.4 59.2 14.4 20.8 0 40-4.8 59.2-14.4l302.4-156.8C918.4 784 944 740.8 944 692.8V334.4c0-48-27.2-92.8-68.8-113.6zM483.2 120c9.6-4.8 19.2-8 28.8-8 9.6 0 20.8 1.6 28.8 6.4l304 156.8c4.8 1.6 8 4.8 12.8 8L512 462.4l-345.6-176c3.2-3.2 8-6.4 12.8-8l304-158.4zm-304 627.2C156.8 736 144 713.6 144 689.6v-344l128 65.6v144c0 12.8 6.4 24 17.6 28.8l22.4 11.2c1.6 1.6 4.8 1.6 6.4 1.6 9.6 0 16-6.4 16-16V443.2l144 73.6v385.6L179.2 747.2zm665.6 0L544 904V516.8l336-171.2v344c0 24-12.8 46.4-35.2 57.6z"
      }
    })]));
  }
};